module.exports = __webpack_public_path__ + "static/media/clone-icon.ac4f2a22.svg";